import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { SearchModel } from 'src/app/models/search-model';
import { BroadcastService } from 'src/app/services/broadcast.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { SearchTerm } from 'src/app/state/user/searches/models/search';
import { ConfigService } from 'src/app/services/config.service';
import { LocaleService } from 'src/app/services/locale.service';
import { Util } from 'src/app/util';

@Component({
  selector: 'app-search-terms',
  templateUrl: './search-terms.component.html',
  styleUrls: ['./search-terms.component.scss'],
})
export class SearchTermsComponent implements OnInit, OnDestroy {
  @Output()
  submitted: EventEmitter<boolean> = new EventEmitter();

  searchModel: SearchModel;
  termsToRender: SearchTerm[];
  searchModelSub = new Subscription();
  hideExploreButton: boolean;
  showLearningExperiencesButton: boolean;
  hideFilters: boolean;
  learningExperiencesButtonLabel: string;
  textDirection: string;

  constructor(
    private configService: ConfigService,
    private localeService: LocaleService,
    private broadcastService: BroadcastService,
    private router: Router
  ) {
    this.learningExperiencesButtonLabel = this.getLearningExperiencesButtonLabel();
    this.showLearningExperiencesButton = this.configService.get().showExploreExperienceButton;

    this.searchModelSub = this.broadcastService.searchModel$.subscribe((model) => {
      this.searchModel = model;
      this.termsToRender = this.getUniqueListBy(this.searchModel.terms, 'term');

      this.hideFilters =
        this.searchModel.explore || this.searchModel.terms.length > 0 || this.searchModel.filters.length > 0;

      this.hideExploreButton = !this.searchModel.excludeNonLeRecords && this.hideFilters;

      this.showLearningExperiencesButton =
        !(this.searchModel.excludeNonLeRecords && this.hideFilters) &&
        this.configService.get().showExploreExperienceButton;
    });
  }

  ngOnInit() {
    this.textDirection = this.localeService.getTextDirection();
  }

  ngOnDestroy() {
    this.searchModelSub.unsubscribe();
  }

  removeTerm(term: SearchTerm) {
    this.submitted.emit(true);
    this.searchModel.removeTerm(term);
    this.searchModel.order = this.searchModel.determineOrder();
    const searchRequest = this.searchModel.toRequest();

    this.router.navigate([], {
      queryParams: {
        query: searchRequest.query,
        order: searchRequest.order,
        save: true,
      },
      queryParamsHandling: 'merge',
    });
  }

  explore() {
    const model = new SearchModel(undefined, this.configService.get().resultsFilterOrder);
    model.explore = true;
    model.save = true;

    this.submitted.emit(true);
    this.router.navigate(['/results'], {
      queryParams: model.toRequest(),
    });
  }

  exploreLearningExperiences() {
    const model = new SearchModel(undefined, this.configService.get().resultsFilterOrder);
    model.explore = true;
    model.save = true;

    this.submitted.emit(true);
    this.router.navigate(['/results'], {
      queryParams: model.toRequestLearningExperiences(),
    });
  }

  private getLearningExperiencesButtonLabel() {
    const fullPrecisionButtonLabel = this.configService.get().exploreExperiencesButtonLabel;
    const learningExperiencesBrandingName = this.configService.get().bookClubName;

    if (Util.isEmptyString(fullPrecisionButtonLabel)) {
      return Util.isEmptyString(learningExperiencesBrandingName)
        ? this.localeService.instant('search.learningExperiences')
        : this.localeService.instant('search.exploreLearningExperiences', {
            brandingName: learningExperiencesBrandingName.toLocaleLowerCase(),
          });
    }

    return fullPrecisionButtonLabel;
  }

  /**
   * Given a SearchTerm array, we filter it based on the key term, to avoid duplicates
   */
  private getUniqueListBy(arr: SearchTerm[], key: string): SearchTerm[] {
    return [...new Map(arr.map((item) => [item[key], item])).values()];
  }
}
